const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24;

const getDateDifference = (date1: Date, date2: Date): number => {
  return Math.ceil((date1.getTime() - date2.getTime()) / MILLISECONDS_IN_A_DAY);
};

export default getDateDifference;
